import { inject, Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { AppService } from '../services/app.service';
import { ApiUsuarioService } from '../services/api-usuario.service';
import { PlatformService } from '../services/platform.service';

@Injectable({
    providedIn: 'root'
})
export class EmbeddedOutsideIframeGuard {

    private readonly _appService = inject(AppService);
    private readonly _apiUsuarioService = inject(ApiUsuarioService);
    private readonly _router = inject(Router);

    canActivate(): boolean | UrlTree {
        if (PlatformService.isInIframe()) {
            return true;
        }

        const credenciais = this._apiUsuarioService.getCredenciais();

        if (credenciais && credenciais.usuarioQueLogou) {
            return true;
        }

        if (!credenciais) {
            return this._router.createUrlTree(['/login']);
        }

        if (!this._appService.isEmbeddedMode()) {
            return this._router.createUrlTree(['/cotacoes']);
        }

        const aplicacaoOrigem = credenciais.aplicacaoOrigem;

        this._apiUsuarioService.limpaSessaoLocal();
        this._appService.redirecionaParaAmbienteExterno(aplicacaoOrigem);

        return this._router.createUrlTree(['/login']);
    }
}
